import styled from "styled-components";
import { SidebarProvider } from "@/components/ui/sidebar";

export const MainSidebarProvider = styled(SidebarProvider)``;


